import Main from '@/views/administracion/obrassolicitudes/configuracion/Main.vue';
import MainPlantillas from '@/views/administracion/obrassolicitudes/configuracion/plantillas/Main.vue';
import MainEtiquetas from '@/views/administracion/obrassolicitudes/configuracion/etiquetas/Main.vue';
import MainFirmas from '@/views/administracion/obrassolicitudes/configuracion/firmas/Main.vue';

const auth = ['Planeación:ver'];
const scopes = ['Planeación:crear', 'Planeación:editar', 'Planeación:eliminar'];

const configuracion = [
  {
    path: 'configuracion',
    meta: {
      title: 'Configuración',
      auth,
    },
    component: Main,
    children: [
      {
        name: 'obrasSolicitudesConfiguracionFirmas',
        path: 'firmas',
        meta: {
          title: 'Firmas',
          auth,
          scopes,
        },
        component: MainFirmas,
        children: [],
      },
      {
        name: 'obrasSolicitudesConfiguracionPlantillas',
        path: 'plantillas',
        meta: {
          title: 'Plantillas',
          auth,
          scopes,
        },
        component: MainPlantillas,
        children: [],
      },
      {
        name: 'obrasSolicitudesConfiguracionEtiquetas',
        path: 'etiquetas',
        meta: {
          title: 'Etiquetas',
          auth,
          scopes,
        },
        component: MainEtiquetas,
        children: [],
      },
    ],
  },
];

export default configuracion;
